import { render, staticRenderFns } from "./PushInfo.vue?vue&type=template&id=6f77361a&scoped=true&"
import script from "./PushInfo.vue?vue&type=script&lang=js&"
export * from "./PushInfo.vue?vue&type=script&lang=js&"
import style0 from "./PushInfo.vue?vue&type=style&index=0&id=6f77361a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77361a",
  null
  
)

export default component.exports